export * from './types';
export var ICON_SCRIPT_URL = 'https://at.alicdn.com/t/c/font_3267196_ls2j6qyyu6t.js';
